import React from "react";
import { observer } from "mobx-react";
import {
	AccountStatementBettingTable,
	AccountStatementPaymentTable,
	AccountStatementTransactionsTable,
} from "../table";
import { useAccountStatementStore } from "@state/hooks/account-statement/useAccountStatementStore";
import { TableSkeletonLoader } from "./TableSkeletonLoader";

export const AccountStatementTableSection = observer(
	function AccountStatementTableSection() {
		const store = useAccountStatementStore();

		if (store.shouldShowSkeletonLoader) {
			return <TableSkeletonLoader />;
		}
		return (
			<>
				<table className="table table--bordered table--shadowy u-mar--top--xsml">
					<AccountStatementPaymentTable />
					<AccountStatementBettingTable />
				</table>

				<AccountStatementTransactionsTable />
			</>
		);
	}
);
